import {
  MESSAGE_MODAL,
  SHOW_PAYMENT_MODAL,
  SHOW_CART_MODAL,
  SHOW_PRODUCT_MODAL,
  SHOW_HOURS_MODAL,
  SHOW_SPLASH,
  SHOW_CONNEXION_MODAL,
  SHOW_SIGNUP,
  SHOW_FORGET_PASSWORD,
  SHOW_ACCOUNT_MODAL,
  IS_MOBILE,
  SET_NAVBAR_HEIGHT,
  SHOW_OVERLAY_COVER,
  SHOW_INACTIVITY_MODAL,
  SET_TERMINAL_TIMEOUT,
  SHOW_HORIZONTAL_SECTION,
  IS_GOOGLE_MAPS_ENABLED,
  SHOW_ADDRESS_MODAL,
  SHOW_CHOOSE_SHOP,
  UPDATE_ADDRESS_TEMP,
  SHOW_UPDATE_INFO,
  SHOW_ORDER_MODAL,
  SHOW_ORDER_STATUS
} from '../actions/types';
import { START_CONTENT } from '../../constants';

const INITIAL_STATE = {
  messageModal: null,
  dataModal: {},
  paymentModal: false,
  cartModal: false,
  productModal: false,
  hoursModal: false,
  connexionModal: false,
  chooseShopModal: false,
  addressModal: false,
  splash: true,
  signUp: false,
  showForgetPassword: false,
  accountModal: false,
  addressInputModal: false,
  isMobile: false,
  navbarHeight: '16px',
  overlayCover: START_CONTENT,
  inactivityModal: false,
  terminalTimeout: null,
  isHorizontalSection: false,
  googleMapsEnabled: false,
  chooseShop: false,
  addressTemp: {},
  updateInfo: false,
  orderModal: false,
  orderStatus: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MESSAGE_MODAL:
      return {
        ...state,
        messageModal: action.payload.message,
        dataModal: action.payload.data
      };
    case SHOW_PAYMENT_MODAL:
      return { ...state, paymentModal: action.payload };
    case SHOW_CART_MODAL:
      return { ...state, cartModal: action.payload };
    case SHOW_PRODUCT_MODAL:
      return { ...state, productModal: action.payload };
    case SHOW_SPLASH:
      return { ...state, splash: action.payload };
    case SHOW_HOURS_MODAL:
      return {
        ...state,
        hoursModal: action.payload
      };
    case SHOW_CONNEXION_MODAL:
      return { ...state, connexionModal: action.payload };
    case SHOW_SIGNUP:
      return { ...state, signUp: action.payload };
    case SHOW_FORGET_PASSWORD:
      return { ...state, showForgetPassword: action.payload };
    case SHOW_ACCOUNT_MODAL:
      return { ...state, accountModal: action.payload };
    case SHOW_ADDRESS_MODAL:
      return { ...state, addressModal: action.payload };
    case SHOW_CHOOSE_SHOP:
      return { ...state, chooseShop: action.payload };
    case IS_MOBILE:
      return { ...state, isMobile: action.payload };
    case SET_NAVBAR_HEIGHT:
      return { ...state, navbarHeight: action.payload };
    case SHOW_OVERLAY_COVER:
      return { ...state, overlayCover: action.payload };
    case SHOW_INACTIVITY_MODAL:
      return { ...state, inactivityModal: action.payload };
    case SET_TERMINAL_TIMEOUT:
      return { ...state, terminalTimeout: action.payload };
    case SHOW_HORIZONTAL_SECTION:
      return { ...state, isHorizontalSection: action.payload };
    case IS_GOOGLE_MAPS_ENABLED:
      return { ...state, googleMapsEnabled: action.payload };
    case UPDATE_ADDRESS_TEMP:
      return { ...state, addressTemp: action.payload };
    case SHOW_UPDATE_INFO:
      return { ...state, updateInfo: action.payload };
    case SHOW_ORDER_MODAL:
      return { ...state, orderModal: action.payload };
    case SHOW_ORDER_STATUS:
      return { ...state, orderStatus: action.payload };
    default:
      return state;
  }
};
